module.exports = __webpack_public_path__ + "img/idle-dj.82dca501.png";